<mat-card>
  <form [formGroup]="invoicesForm" (ngSubmit)="submit()">
    <mat-card-header>
      <mat-card-title>
        <h4>
          <div *ngIf="editMode; else newInvoices">
            <span i18n>Invoice</span>&nbsp;
            <span>{{ currentInvoicesNr }}</span>
          </div>
          <ng-template #newInvoices>
            <span i18n>New Invoice</span>&nbsp;
          </ng-template>
        </h4>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content>
      <div class="invoices-container">
        <div class="invoices-meta">
          <div class="invoices-meta-form-left">
            <div>
              <mat-form-field style="width:100px !important">
                <input type="text" placeholder="Invoice Nr" i18n-placeholder matInput formControlName="invoiceNr">              
              </mat-form-field>   
              /
              <mat-form-field style="width:20px !important; margin-right: 45px !important">
                  <input type="text" i18n-placeholder matInput maxlength="2" formControlName="invoiceNr2"> 
              </mat-form-field>
              <mat-form-field class="mat-form-field-lg">
                <input type="text" placeholder="Order" matInput formControlName="order" [matAutocomplete]="autoOrder">
                <mat-autocomplete #autoOrder="matAutocomplete" [displayWith]="orderDisplay" (optionSelected)="getItemsByOrder($event)">
                  <mat-option *ngFor="let order of filteredOrders | async" [value]="order" [disabled]="order.authorized !== 'yes'">                                   
                    {{ order.orderNr }}
                  </mat-option>
                </mat-autocomplete>
              </mat-form-field>
              <mat-form-field>
                <input matInput placeholder="Invoice Date" [matDatepicker]="invoiceDate" formControlName="invoiceDate">
                <mat-datepicker-toggle matSuffix [for]="invoiceDate"></mat-datepicker-toggle>
                <mat-datepicker #invoiceDate></mat-datepicker>
              </mat-form-field>
            </div>
            <div>
              <mat-form-field style="width:540px !important">
                <textarea matInput matTextareaAutosize matAutosizeMinRows="3" matAutosizeMaxRows="120" placeholder="Description" class="form-control" formControlName="note" i18n-placeholder></textarea>
              </mat-form-field>
            </div>
            <div>
              <app-file-upload *ngIf="!invoiceSentToAccounting" (url)="getDownloadUrl($event)" (uploadProcess)="getUploadProcess($event)"></app-file-upload>
              <a *ngIf="invoicesForm.get('downloadUrl').value" [href]="invoicesForm.get('downloadUrl').value" class="invoiceFile" target="_blank" mat-button>
                  <mat-icon matListIcon>attach_file</mat-icon>
                  <span class="menu-label" i18n="Invoice file">See file</span>
              </a>
            </div> 
            <div>
              <p *ngIf="!vendorHasNda && vendorNdaFieldIsSet" class="message">Vendor NDA file is set in the CRM but your user cannot access it</p>
              <p *ngIf="!vendorHasNda && !vendorNdaFieldIsSet" class="message">Vendor has no NDA file</p>
              <a *ngIf="vendorHasNda" [href]="'https://drive.google.com/open?id=' + ndaFile.id" target="_blank">Open NDA file</a>
            </div>
            <mat-card-actions>
              <button mat-raised-button type="submit" [disabled]="invoiceSentToAccounting || 
                                                                                invoicesForm.invalid || 
                                                                                invoicesAdding || 
                                                                                disabledSubmit || 
                                                                                numberItemSelected == 0 ||
                                                                                !vendorHasNda">
                <span *ngIf="editMode; else elseBlock" i18n>Update</span>
                <ng-template #elseBlock>
                  <span i18n>Submit</span>
                </ng-template>
              </button>
              <a mat-raised-button routerLink="/invoices">
                <span i18n>Cancel</span>
              </a>
              <button *ngIf="editMode && !invoiceSentToAccounting && cosmoEnabled" mat-raised-button (click)="sendToAccounting()" [disabled]="invoicesAdding || disabledSubmit">
                <span i18n>Send To Accounting</span>
              </button>
            </mat-card-actions>       
          </div>
          <div class="invoices-meta-form-right">
            <div class="invoices-entry-array">
              <h5>Materials: </h5>
              
              <div class="example-container mat-elevation-z8">
                <mat-table [dataSource]="dataSourceItems" matSort>

                  <ng-container matColumnDef="selected">
                    <mat-header-cell *matHeaderCellDef i18n>In this invoice?</mat-header-cell>
                    <mat-cell *matCellDef="let row; let i = index">
                      <mat-checkbox [disabled]="invoiceSentToAccounting || row.amount == 0" (change)="changeSelectedItem($event, i, row.amount)" [checked]="row.selected" ></mat-checkbox>
                    </mat-cell>                 
                  </ng-container>
              
                  <ng-container matColumnDef="description">
                    <mat-header-cell *matHeaderCellDef i18n>Description</mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{ row.description | ellipsis:100 }} </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="descriptionCopy">
                    <mat-header-cell *matHeaderCellDef i18n>Descr. copy</mat-header-cell>
                    <mat-cell *matCellDef="let row; let i = index">
                      <mat-checkbox [disabled]="invoiceSentToAccounting || !row.selected" (change)="copySelectedDescription($event, i)" ></mat-checkbox>
                    </mat-cell>                 
                  </ng-container>

                  <ng-container matColumnDef="invoiceDescription">
                    <mat-header-cell *matHeaderCellDef i18n>Invoice Description</mat-header-cell>
                    <mat-cell *matCellDef="let row"> 
                      <textarea matInput [disabled]="invoiceSentToAccounting || !row.selected" [value]="row.invoiceDescription" matTextareaAutosize matAutosizeMinRows="1" matAutosizeMaxRows="2" class="form-control" i18n-placeholder></textarea>
                    </mat-cell>
                  </ng-container>
              
                  <ng-container matColumnDef="quantity">
                    <mat-header-cell *matHeaderCellDef i18n>Quantity</mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{ row.quantity }} </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="costEach">
                    <mat-header-cell *matHeaderCellDef i18n>Price per unit</mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{ row.costEach | currency:'EUR' }} </mat-cell>
                  </ng-container>

                  <ng-container matColumnDef="amount">
                    <mat-header-cell *matHeaderCellDef i18n>Amount</mat-header-cell>
                    <mat-cell *matCellDef="let row; let i = index">
                      <input class="no-spinner" [disabled]="invoiceSentToAccounting || !row.selected" [value]="row.selected ? row.amount : 0" (keyup)="changeItemAmount($event.target.value, i)" matInput type="number" min="0" i18n-placeholder>
                    </mat-cell>                    
                  </ng-container>
              
                  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                  <mat-row *matRowDef="let row; columns: displayedColumns">
                  </mat-row>
                </mat-table>
              
                <mat-paginator [length]="dataSourceItems.resultsLength" [pageSizeOptions]="[100]"></mat-paginator>
              </div>

            </div>             
          </div>
        </div>
      </div>
    </mat-card-content> 
  </form>
</mat-card>


// WEBPACK FOOTER //
// ./src/app/invoices/invoices-add/invoices-add.component.html